var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRightCircleLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16.5C2 8.76801 8.26801 2.5 16 2.5C23.732 2.5 30 8.76801 30 16.5C30 24.232 23.732 30.5 16 30.5C8.26801 30.5 2 24.232 2 16.5ZM16 1C7.43959 1 0.5 7.93959 0.5 16.5C0.5 25.0604 7.43959 32 16 32C24.5604 32 31.5 25.0604 31.5 16.5C31.5 7.93959 24.5604 1 16 1ZM17.2677 10.8071L22.4302 15.9696C22.7231 16.2625 22.7231 16.7374 22.4302 17.0303L17.2677 22.1928C16.9748 22.4857 16.5 22.4857 16.2071 22.1928C15.9142 21.8999 15.9142 21.425 16.2071 21.1321L20.0892 17.25H10.0999C9.68569 17.25 9.3499 16.9142 9.3499 16.5C9.3499 16.0858 9.68569 15.75 10.0999 15.75H20.0892L16.2071 11.8678C15.9142 11.5749 15.9142 11.1 16.2071 10.8071C16.5 10.5143 16.9748 10.5143 17.2677 10.8071Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightCircleLined);
export default __webpack_public_path__ + "static/media/ic_arrow_right_circle_lined.78a9182721150f4eeafeaaea9fd78b52.svg";
export { ForwardRef as ReactComponent };